import { Select, SelectProps } from 'antd';
import { BaseSelectRef } from 'rc-select/lib/BaseSelect';
import { forwardRef, useCallback, useEffect, useState } from 'react';

import SellerSelect from '../../../../common/components/Fields/SellerSelect';
import { useAdminSellerInSettlementListLazyQuery } from '../../graphql/seller.generated';

export type SelectFieldProps = SelectProps<number> & {
  initialLoad?: boolean;
};

const SettlementSellerSelect = forwardRef<BaseSelectRef, SelectFieldProps>(
  function ({ initialLoad, ...props }, ref) {
    const [initialOption, setInitialOption] = useState<
      null | undefined | { value: number; label: string }
    >(null);

    const [fetch] = useAdminSellerInSettlementListLazyQuery();
    const fetchSeller = useCallback(async () => {
      if (!props.value) {
        setInitialOption(undefined);
        return;
      }

      const { data } = await fetch({
        variables: {
          adminSellerId: props.value,
        },
      });

      if (data?.adminSeller) {
        setInitialOption({
          value: data.adminSeller.id,
          label: data.adminSeller.name,
        });
      }
    }, [fetch, props.value]);

    useEffect(() => {
      fetchSeller();
    }, []);

    if (initialOption === null) return <Select className={props.className} />;

    return (
      <SellerSelect
        ref={ref}
        initialLoad={initialLoad}
        className={'w-full'}
        initialOption={initialOption}
        {...props}
      />
    );
  }
);

export default SettlementSellerSelect;
